import { a as r, I as t, j as a, d as o } from "./IconTemplate-c24f5ddb.mjs";
import "react";
const e = (l) => /* @__PURE__ */ r(t, { ...l, name: l.name || "ImageError", viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ a(
    "path",
    {
      d: "M696.43 465.25c40.61 0 73.53-32.72 73.53-73.09s-32.96-73.08-73.53-73.08-73.54 32.72-73.54 73.08 32.92 73.09 73.54 73.09M535.74 650.62l-273.61-259.4a56.19 56.19 0 0 0-15.36 11.58l-114 119.63-6-222.77c-.73-26.82 20.84-49.41 47.67-50.14l201.77-5.44 47.34-50-250.43 6.75C119 202.33 76.33 247.17 77.78 301l7.32 271.4 4.5 166.78C91.06 793 136.05 835.47 190.2 834l176-4.75 12-.32 47.34-50 116.18-122.64z",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  ),
  ",",
  /* @__PURE__ */ a(
    "path",
    {
      d: "m861.71 214.8-242.83-33.86-55.09 41.46L855 263a49.05 49.05 0 0 1 41.79 55.13l-54.33 389.59-120.87-159.05A59.86 59.86 0 0 0 638.06 537l-44 33.08 65.07 86.15L603.84 698l-79.57 60.1-54.92 41.48 34.17 4.76 270.73 37.76a97.55 97.55 0 0 0 109.88-79.6 22.37 22.37 0 0 0 .65-3.44l60.53-434.16c7.44-53.32-29.95-102.62-83.6-110.1",
      fill: "currentColor",
      fillOpacity: "0.9"
    }
  )
] });
e.defaultProps = o;
export {
  e as default
};
